export default "__VITE_ASSET__T7k84qmI__"